import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";
import { CreateChatRoomBody } from "../../types/chat";

export const useCreateChatRoom = (body: CreateChatRoomBody, enabled: boolean = false) => {
  return useQuery({
    queryKey: ["chat", "createRoom", body.pID],
    queryFn: async () => {
      const response = await chatApi.createChatRoom(body);
      return response;
    },
    enabled: enabled && !!body.pID,
    refetchOnMount: true,
    staleTime: 0, // Luôn refetch để đảm bảo dữ liệu phòng mới nhất
  });
};
